import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import AnimatedBackground from './components/AnimatedBackground';
import SetupPage from './pages/SetupPage';

// Page imports
import LandingPage from './pages/LandingPage';
import PromptsPage from './pages/PromptsPage';
import GAdsConnectPage from './pages/GAdsConnectPage';
import GSCConnectPage from './pages/GSCConnectPage';
import GA4ConnectPage from './pages/GA4ConnectPage';
import MetaConnectPage from "./pages/MetaConnectPage";
import GMCConnectPage from "./pages/GMCConnectPage";

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0a0a0a',
      paper: '#141414',
    },
    primary: {
      main: '#4285f4',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#34a853',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Router>
        <Box
          className="App"
          sx={{
            height: '100vh',
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #000000 100%)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
          }}
        >
          <AnimatedBackground />
          <Navbar sx={{ position: 'relative', zIndex: 2 }} />
          <Box sx={{ 
            flexGrow: 1, 
            position: 'relative', 
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            // Only show scrollbar when content overflows
            overflowY: 'auto'
          }}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/prompts" element={<PromptsPage />} />
              <Route path="/connect/gads" element={<GAdsConnectPage />} />
              <Route path="/connect/gsc" element={<GSCConnectPage />} />
              <Route path="/connect/ga4" element={<GA4ConnectPage/>} />
              <Route path="/connect/gmc" element={<GMCConnectPage/>} />
              <Route path="/connect/meta" element={<MetaConnectPage/>} />
              <Route path="*" element={<Navigate to="/" replace />} />
              <Route path="/setup" element={<SetupPage />} />
            </Routes>
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
